// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "th.cell-check,th.cell-radio{text-align:center}\n", "",{"version":3,"sources":["webpack://./js/htk/columns/check/style.scss"],"names":[],"mappings":"AACA,4BAEC,iBAAkB","sourcesContent":["\nth.cell-check,\nth.cell-radio {\n\ttext-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
